import { render, staticRenderFns } from "./DepositMatches.vue?vue&type=template&id=13b684d4&"
import script from "./DepositMatches.vue?vue&type=script&lang=js&"
export * from "./DepositMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports